import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Solicitud from "./Solicitud";
import SolicitudesMisRequerimientos from "./SolicitudesMisRequerimientos.js";
import {getRequestList} from '../api.js';

export default class Requerimientos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      requestList: [],
      indexRequestSelected: null
    }
  }
  
  componentDidMount() {
    this.props.changeHeaderClass("medium");
    this.fetchData();
  }

  fetchData(){
    this.setState({isLoading: true});

    getRequestList(null, null, null, null, null, (err, res) => {
      this.setState({isLoading: false});

      if (err || !res || res.status !== "ok") return;

      this.setState({requestList: res.data});
    }, this.props.isEmpresas ? "empresas": null)
  }

  onRequestSelected = (indexRequestSelected) => this.setState({indexRequestSelected});

  render() {
    return (
      <Switch>
        <Route exact path="/requerimientos/">
          <SolicitudesMisRequerimientos
            isLoading={this.state.isLoading}
            requestList={this.state.requestList}
            onRequestSelected={(index)=> this.onRequestSelected(index)}
          />
        </Route>
        <Route path="/requerimientos/detalle">
          <Solicitud
            createActionNotification={this.props.createActionNotification}
            changeHeaderClass={this.props.changeHeaderClass}
            user={this.props.user}
            dataRequest={this.state.requestList[this.state.indexRequestSelected]}
          />
        </Route>
      </Switch>
    );
  }
}
